var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"font-big-icon",attrs:{"viewBox":"0 0 13 14","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M0 0v2.2h5.4V14h2.2V2.2H13V0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }